import styled from '@emotion/styled';
import { Responsive, ResponsivePicture } from '@/ui';
import { theme } from '../../../styles/theme';

export const HighlightImage = styled(ResponsivePicture)`
	border-radius: ${theme.card?.borderRadius};
	overflow: hidden;

	grid-row: 1;
	grid-column: 1 / span 3;

	// IE11 fix
	display: block;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		height: 430px;
		grid-row: 1 / span 2;
		border-radius: 0;
	}
`;
